import React from 'react';
import { Button, Form } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import '../views/css/map-drop-point.css'

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export default function DownloadExcel({
  excelData,           // Blob | ArrayBuffer | Worksheet | JSON[]
  fileName = 'export.xlsx',
  name = 'Export Excel',
  disabledOption
}) {
  const ensureXlsx = (n) => (String(n).toLowerCase().endsWith('.xlsx') ? n : `${n}.xlsx`);

  const exportToExcel = async () => {
    let blob;

    if (excelData instanceof Blob) {
      // Case 1: API already gave you the XLSX file
      blob = excelData;
    } else if (excelData instanceof ArrayBuffer || ArrayBuffer.isView(excelData)) {
      // Case 2: You have binary data
      blob = new Blob([excelData], { type: XLSX_MIME });
    } else {
      // Case 3: You have a Worksheet or JSON and want to generate the file
      const ws = (excelData && !Array.isArray(excelData))
        ? excelData // assume it's an XLSX worksheet object
        : XLSX.utils.json_to_sheet(excelData || []); // or build from JSON rows

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'company data export');

      const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      blob = new Blob([buf], { type: XLSX_MIME });
    }

    saveAs(blob, ensureXlsx(fileName));
  };

  return (
    <Form>
      <Button
        variant="info"
        className="excel-btn"
        onClick={exportToExcel}
        disabled={disabledOption ?? false}
      >
        {name ?? 'Export Excel'}
      </Button>
    </Form>
  );
}
